// import React, { useState, useEffect, useCallback } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { ArrowLeft, Upload, Trash2, Image, Video, Loader, X, Star } from 'lucide-react';
// import { uploadProjectMedia, deleteProjectMedia } from '../utils/api';
// import toast from 'react-hot-toast';
// import ConfirmModal from '../components/ConfirmModal';

// export default function ProjectMediaPage() {
//   const { id } = useParams();
//   const [media, setMedia] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [dragOver, setDragOver] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   // In production this would fetch from API
//   const addMedia = (items) => setMedia(prev => [...prev, ...items]);

//   const handleFiles = useCallback(async (files) => {
//     if (!files || files.length === 0) return;
//     const fileList = Array.from(files);
//     const maxSize = 100 * 1024 * 1024; // 100MB
//     const oversized = fileList.filter(f => f.size > maxSize);
//     if (oversized.length) { toast.error('Some files exceed 100MB limit'); return; }

//     setUploading(true);
//     setUploadProgress(0);
//     try {
//       const fd = new FormData();
//       fileList.forEach(f => fd.append('files[]', f));

//       const res = await uploadProjectMedia(id, fd);
//       addMedia(res.data.data || []);
//       toast.success(`${fileList.length} file(s) uploaded successfully!`);
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Upload failed');
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   }, [id]);

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     handleFiles(e.dataTransfer.files);
//   };

//   const handleDeleteMedia = async () => {
//     try {
//       await deleteProjectMedia(id, deleteId);
//       setMedia(prev => prev.filter(m => m.id !== deleteId));
//       toast.success('Media deleted');
//       setDeleteId(null);
//     } catch {
//       toast.error('Failed to delete');
//     }
//   };

//   const images = media.filter(m => m.type === 'image');
//   const videos = media.filter(m => m.type === 'video');

//   return (
//     <div className="max-w-5xl">
//       <div className="flex items-center gap-3 mb-6">
//         <Link to="/projects" className="btn-ghost p-2"><ArrowLeft size={16} /></Link>
//         <div>
//           <h1 className="text-xl font-semibold text-white">Manage Media</h1>
//           <p className="text-white/40 text-sm">Project ID: {id} · {media.length} files total</p>
//         </div>
//       </div>

//       {/* Upload Zone */}
//       <div
//         onDrop={handleDrop}
//         onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
//         onDragLeave={() => setDragOver(false)}
//         className={`card p-8 mb-6 border-2 border-dashed text-center transition-all duration-200 ${
//           dragOver ? 'border-primary-400 bg-primary-500/5' : 'border-white/10 hover:border-white/20'
//         }`}
//       >
//         {uploading ? (
//           <div className="flex flex-col items-center gap-3">
//             <Loader size={24} className="text-primary-400 animate-spin" />
//             <p className="text-white/60 text-sm">Uploading files...</p>
//           </div>
//         ) : (
//           <>
//             <Upload size={32} className="mx-auto mb-3 text-white/20" />
//             <p className="text-white/60 text-sm mb-1">Drag & drop images or videos here</p>
//             <p className="text-white/30 text-xs mb-4">JPG, PNG, WebP, MP4, MOV · Max 100MB per file</p>
//             <label className="btn-primary cursor-pointer">
//               <Upload size={14} /> Choose Files
//               <input
//                 type="file"
//                 multiple
//                 accept="image/*,video/*"
//                 onChange={e => handleFiles(e.target.files)}
//                 className="hidden"
//               />
//             </label>
//           </>
//         )}
//       </div>

//       {/* Images Grid */}
//       {images.length > 0 && (
//         <div className="card p-5 mb-4">
//           <div className="flex items-center gap-2 mb-4">
//             <Image size={15} className="text-primary-400" />
//             <h2 className="font-medium text-white text-sm">Images ({images.length})</h2>
//           </div>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
//             {images.map(img => (
//               <div key={img.id} className="group relative aspect-square bg-surface-700 rounded-lg overflow-hidden">
//                 <img src={img.url} alt={img.alt_text || 'Project image'} className="w-full h-full object-cover" />
//                 <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-200 flex items-center justify-center">
//                   <button
//                     onClick={() => setDeleteId(img.id)}
//                     className="opacity-0 group-hover:opacity-100 p-1.5 bg-red-500 rounded-md text-white transition-opacity"
//                   >
//                     <Trash2 size={12} />
//                   </button>
//                 </div>
//                 {img.is_featured && (
//                   <div className="absolute top-1 left-1">
//                     <Star size={10} className="text-primary-400 fill-primary-400" />
//                   </div>
//                 )}
//                 <div className="absolute bottom-1 right-1 text-[9px] text-white/40 bg-black/50 px-1 rounded">
//                   {img.file_size ? `${(img.file_size / 1024).toFixed(0)}KB` : ''}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Videos */}
//       {videos.length > 0 && (
//         <div className="card p-5">
//           <div className="flex items-center gap-2 mb-4">
//             <Video size={15} className="text-primary-400" />
//             <h2 className="font-medium text-white text-sm">Videos ({videos.length})</h2>
//           </div>
//           <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
//             {videos.map(video => (
//               <div key={video.id} className="group relative bg-surface-700 rounded-lg overflow-hidden">
//                 <video src={video.url} className="w-full aspect-video object-cover" preload="metadata" />
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <div className="w-10 h-10 rounded-full bg-black/50 flex items-center justify-center">
//                     <Video size={16} className="text-white" />
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => setDeleteId(video.id)}
//                   className="absolute top-2 right-2 p-1.5 bg-red-500 rounded-md text-white opacity-0 group-hover:opacity-100 transition-opacity"
//                 >
//                   <Trash2 size={12} />
//                 </button>
//                 <div className="p-2">
//                   <p className="text-white/50 text-xs truncate">{video.file_name}</p>
//                   <p className="text-white/25 text-[10px]">
//                     {video.file_size ? `${(video.file_size / (1024 * 1024)).toFixed(1)}MB` : ''}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {media.length === 0 && !uploading && (
//         <div className="card p-12 text-center">
//           <Image size={40} className="mx-auto mb-3 text-white/10" />
//           <p className="text-white/30 text-sm">No media uploaded yet</p>
//           <p className="text-white/20 text-xs mt-1">Use the upload zone above to add images and videos</p>
//         </div>
//       )}

//       <ConfirmModal
//         open={!!deleteId}
//         title="Delete Media"
//         message="Are you sure you want to delete this file? This action cannot be undone."
//         onConfirm={handleDeleteMedia}
//         onCancel={() => setDeleteId(null)}
//         danger
//       />
//     </div>
//   );
// }


import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Upload, Trash2, Image, Video, Loader, Star, CloudUpload, CheckCircle2, FileImage, Film } from 'lucide-react';
import { getProjectMedia, uploadProjectMedia, deleteProjectMedia, getProject,    } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

export default function ProjectMediaPage() {
  const { id } = useParams();
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]); // [{name, size, progress, done, error}]
  const [deleteId, setDeleteId] = useState(null);
  const [dragOver, setDragOver] = useState(false);

  // Fetch existing media
  useEffect(() => {
    setLoading(true);

    getProject(id)   // 👈 CHANGE HERE
      .then(res => {
        const project = res.data.data;
        setMedia(project.media || []);   // 👈 IMPORTANT
      })
      .catch(() => toast.error('Failed to load media'))
      .finally(() => setLoading(false));

  }, [id]);

  const handleFiles = useCallback(async (files) => {
    if (!files || files.length === 0) return;
    const fileList = Array.from(files);
    const maxSize = 100 * 1024 * 1024;
    const oversized = fileList.filter(f => f.size > maxSize);
    if (oversized.length) {
      toast.error(`${oversized.length} file(s) exceed 100MB limit`);
      return;
    }

    // Show preview queue
    const queue = fileList.map(f => ({
      name: f.name,
      size: f.size,
      progress: 0,
      done: false,
      error: false,
    }));
    setUploadFiles(queue);
    setUploading(true);

    try {
      const fd = new FormData();
      fileList.forEach(f => fd.append('files[]', f));

      // Update progress simulation while uploading
      const progressInterval = setInterval(() => {
        setUploadFiles(prev => prev.map(f => (!f.done && !f.error ? { ...f, progress: Math.min(90, f.progress + 15) } : f)));
      }, 300);

      const res = await uploadProjectMedia(id, fd);

      clearInterval(progressInterval);
      setUploadFiles(prev => prev.map(f => ({ ...f, progress: 100, done: true })));
      setMedia(prev => [...prev, ...(res.data.data || [])]);
      toast.success(`${fileList.length} file(s) uploaded!`);

      setTimeout(() => setUploadFiles([]), 1500);
    } catch (err) {
      setUploadFiles(prev => prev.map(f => ({ ...f, error: true })));
      toast.error(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  }, [id]);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleDeleteMedia = async () => {
    try {
      await deleteProjectMedia(id, deleteId);
      setMedia(prev => prev.filter(m => m.id !== deleteId));
      toast.success('Media deleted');
      setDeleteId(null);
    } catch {
      toast.error('Failed to delete');
    }
  };

  const formatSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const images = media.filter(m => m.type === 'image');
  const videos = media.filter(m => m.type === 'video');

  return (
    <div className="max-w-5xl">
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <Link
          to="/projects"
          className="w-10 h-10 flex items-center justify-center rounded-xl text-white/40 hover:text-white hover:bg-white/8 border border-white/8 hover:border-white/15 transition-all"
        >
          <ArrowLeft size={17} />
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-white tracking-tight">Media Library</h1>
          <p className="text-white/40 text-sm mt-0.5">
            Project #{id} · {loading ? '—' : `${media.length} files · ${images.length} images · ${videos.length} videos`}
          </p>
        </div>

        <div className="ml-auto">
          <label className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-violet-500 to-indigo-500 hover:from-violet-400 hover:to-indigo-400 text-white text-sm font-semibold rounded-xl cursor-pointer transition-all shadow-lg shadow-violet-500/20 hover:-translate-y-0.5">
            <Upload size={14} strokeWidth={2.5} /> Upload Files
            <input type="file" multiple accept="image/*,video/*" onChange={e => handleFiles(e.target.files)} className="hidden" />
          </label>
        </div>
      </div>

      {/* Drop Zone */}
      <div
        onDrop={handleDrop}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        className={`relative rounded-2xl border-2 border-dashed p-8 mb-6 text-center transition-all duration-200 ${
          dragOver
            ? 'border-violet-400 bg-violet-500/8 scale-[1.01]'
            : 'border-white/10 hover:border-white/20 bg-white/2 hover:bg-white/3'
        }`}
      >
        {uploading || uploadFiles.length > 0 ? (
          <div className="space-y-3">
            <div className="flex items-center justify-center gap-2 text-white/60 text-sm mb-4">
              <Loader size={16} className="animate-spin text-violet-400" />
              <span>{uploadFiles.filter(f => f.done).length}/{uploadFiles.length} files processed</span>
            </div>
            <div className="max-w-sm mx-auto space-y-2">
              {uploadFiles.map((f, i) => (
                <div key={i} className="flex items-center gap-3 text-left">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                    {f.done
                      ? <CheckCircle2 size={14} className="text-emerald-400" />
                      : f.error
                      ? <span className="text-red-400 text-xs">✕</span>
                      : <Loader size={13} className="animate-spin text-violet-400" />
                    }
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="text-white/60 text-xs truncate">{f.name}</p>
                      <p className="text-white/30 text-xs shrink-0 ml-2">{formatSize(f.size)}</p>
                    </div>
                    <div className="h-1 bg-white/8 rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full transition-all duration-300 ${f.error ? 'bg-red-500' : f.done ? 'bg-emerald-500' : 'bg-violet-500'}`}
                        style={{ width: `${f.progress}%` }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center transition-colors ${dragOver ? 'bg-violet-500/20' : 'bg-white/5'}`}>
              <CloudUpload size={28} className={`transition-colors ${dragOver ? 'text-violet-400' : 'text-white/20'}`} />
            </div>
            <p className="text-white/60 text-sm font-medium mb-1">
              {dragOver ? 'Drop files here' : 'Drag & drop files here'}
            </p>
            <p className="text-white/25 text-xs mb-4">Images (JPG, PNG, WebP) and Videos (MP4, MOV) · Max 100MB each</p>
            <label className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white/8 hover:bg-white/12 border border-white/10 text-white/60 hover:text-white text-sm font-medium cursor-pointer transition-all">
              <Upload size={14} /> Browse Files
              <input type="file" multiple accept="image/*,video/*" onChange={e => handleFiles(e.target.files)} className="hidden" />
            </label>
          </>
        )}
      </div>

      {/* Loading skeleton */}
      {loading && (
        <div className="rounded-2xl border border-white/8 bg-white/3 p-6">
          <div className="h-4 w-24 bg-white/5 rounded-full animate-pulse mb-5" />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="aspect-square rounded-xl bg-white/5 animate-pulse" />
            ))}
          </div>
        </div>
      )}

      {/* Images */}
      {!loading && images.length > 0 && (
        <div className="rounded-2xl border border-white/8 bg-white/3 p-6 mb-4">
          <div className="flex items-center gap-2.5 mb-5">
            <div className="w-7 h-7 rounded-lg bg-violet-500/15 flex items-center justify-center">
              <FileImage size={13} className="text-violet-400" />
            </div>
            <h2 className="font-semibold text-white text-sm">Images</h2>
            <span className="ml-1 text-xs text-white/30 bg-white/5 px-2 py-0.5 rounded-full">{images.length}</span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {images.map(img => (
              <div key={img.id} className="group relative aspect-square bg-white/5 rounded-xl overflow-hidden border border-white/8 hover:border-white/20 transition-all">
                <img
                  src={img.url}
                  alt={img.alt_text || 'Project image'}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-200" />

                {/* Actions */}
                <div className="absolute inset-0 flex items-end justify-between p-2 opacity-0 group-hover:opacity-100 transition-all duration-200">
                  <div className="text-[10px] text-white/60 bg-black/40 backdrop-blur px-1.5 py-0.5 rounded-md">
                    {formatSize(img.file_size)}
                  </div>
                  <button
                    onClick={() => setDeleteId(img.id)}
                    className="p-1.5 bg-red-500/80 hover:bg-red-500 backdrop-blur rounded-lg text-white transition-colors"
                    title="Delete"
                  >
                    <Trash2 size={11} />
                  </button>
                </div>

                {/* Featured badge */}
                {img.is_featured && (
                  <div className="absolute top-1.5 left-1.5 flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-amber-500/30 backdrop-blur border border-amber-500/30">
                    <Star size={9} className="text-amber-400 fill-amber-400" />
                  </div>
                )}
              </div>
            ))}

            {/* Add more button */}
            <label className="aspect-square rounded-xl border-2 border-dashed border-white/10 hover:border-violet-500/40 hover:bg-violet-500/5 flex flex-col items-center justify-center gap-1.5 cursor-pointer transition-all group">
              <Upload size={16} className="text-white/20 group-hover:text-violet-400 transition-colors" />
              <span className="text-[10px] text-white/25 group-hover:text-violet-400 transition-colors font-medium">Add more</span>
              <input type="file" multiple accept="image/*" onChange={e => handleFiles(e.target.files)} className="hidden" />
            </label>
          </div>
        </div>
      )}

      {/* Videos */}
      {!loading && videos.length > 0 && (
        <div className="rounded-2xl border border-white/8 bg-white/3 p-6 mb-4">
          <div className="flex items-center gap-2.5 mb-5">
            <div className="w-7 h-7 rounded-lg bg-blue-500/15 flex items-center justify-center">
              <Film size={13} className="text-blue-400" />
            </div>
            <h2 className="font-semibold text-white text-sm">Videos</h2>
            <span className="ml-1 text-xs text-white/30 bg-white/5 px-2 py-0.5 rounded-full">{videos.length}</span>
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
            {videos.map(video => (
              <div key={video.id} className="group relative rounded-xl overflow-hidden border border-white/8 hover:border-white/20 bg-white/5 transition-all">
                <div className="relative aspect-video bg-black/30">
                  <video
                    src={video.url}
                    className="w-full h-full object-cover"
                    preload="metadata"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-11 h-11 rounded-full bg-black/50 backdrop-blur border border-white/20 flex items-center justify-center">
                      <Video size={16} className="text-white ml-0.5" />
                    </div>
                  </div>
                  <button
                    onClick={() => setDeleteId(video.id)}
                    className="absolute top-2 right-2 p-1.5 bg-red-500/70 hover:bg-red-500 rounded-lg text-white opacity-0 group-hover:opacity-100 transition-all"
                  >
                    <Trash2 size={11} />
                  </button>
                </div>
                <div className="px-3 py-2.5">
                  <p className="text-white/60 text-xs font-medium truncate">{video.file_name}</p>
                  <p className="text-white/25 text-[10px] mt-0.5">{formatSize(video.file_size)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Empty state */}
      {!loading && media.length === 0 && uploadFiles.length === 0 && (
        <div className="rounded-2xl border border-white/8 bg-white/2 p-16 text-center">
          <div className="w-20 h-20 mx-auto mb-5 rounded-2xl bg-white/5 flex items-center justify-center">
            <FileImage size={32} className="text-white/10" />
          </div>
          <p className="text-white/40 text-base font-medium">No media yet</p>
          <p className="text-white/20 text-sm mt-1 mb-6">Upload images and videos to showcase this project</p>
          <label className="inline-flex items-center gap-2 px-4 py-2.5 bg-white/8 hover:bg-white/12 border border-white/10 text-white/50 hover:text-white text-sm font-medium rounded-xl cursor-pointer transition-all">
            <Upload size={14} /> Upload First File
            <input type="file" multiple accept="image/*,video/*" onChange={e => handleFiles(e.target.files)} className="hidden" />
          </label>
        </div>
      )}

      <ConfirmModal
        open={!!deleteId}
        title="Delete Media"
        message="Are you sure you want to delete this file? This action cannot be undone."
        onConfirm={handleDeleteMedia}
        onCancel={() => setDeleteId(null)}
        danger
      />
    </div>
  );
}